import { render, staticRenderFns } from "./MyImgTextListEdit.vue?vue&type=template&id=0b4b5df4&scoped=true"
import script from "./MyImgTextListEdit.vue?vue&type=script&lang=js"
export * from "./MyImgTextListEdit.vue?vue&type=script&lang=js"
import style0 from "./MyImgTextListEdit.vue?vue&type=style&index=0&id=0b4b5df4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4b5df4",
  null
  
)

export default component.exports